import { render } from "./OrderPlacement.vue?vue&type=template&id=680d2ffe"
import script from "./OrderPlacement.vue?vue&type=script&lang=js"
export * from "./OrderPlacement.vue?vue&type=script&lang=js"

import "./OrderPlacement.vue?vue&type=style&index=0&id=680d2ffe&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__